import capterra from '@images/capterra.svg';
import capterraLogo from '@images/capterraLogo.svg';
import crozdesk from '@images/crozdesk.svg';
import g2ReviewStars from '@images/g2-review-stars.svg';
import softwareAdvice from '@images/softwareAdvice.svg';
import trustpilot from '@images/trustpilot.svg';
import trustpilotLogo from '@images/trustpilotLogo.svg';
import trustRadius from '@images/trustRadius.svg';

export default {
    rates: [
        {
            alt: 'Software Advice',
            id: 1,
            link: 'https://www.softwareadvice.com/hr/traqq-profile/',
            src: softwareAdvice,
            style: { maxWidth: '138px' }
        },
        {
            alt: 'crozdesk',
            id: 2,
            link: 'https://crozdesk.com/software/traqq',
            src: crozdesk,
            style: { maxWidth: '138px' }
        },
        {
            alt: 'Trustpilot',
            id: 3,
            link: 'https://www.trustpilot.com/review/traqq.com',
            src: trustpilot,
            style: { maxWidth: '138px' }
        },
        {
            alt: 'Capterra',
            id: 4,
            link: 'https://www.capterra.com/p/230726/Traqq/',
            src: capterra,
            style: { maxWidth: '138px' }
        },
        {
            alt: 'TrustRadius',
            id: 5,
            link: 'https://www.trustradius.com/products/traqq/reviews',
            src: trustRadius,
            style: { maxWidth: '138px' }
        },
        {
            alt: 'G2 reviews rating',
            id: 6,
            link: 'https://www.g2.com/products/traqq/reviews',
            src: g2ReviewStars,
            style: { maxWidth: '138px' }
        }
    ],
    services: [
        {
            author: 'Adam C.',
            bg: 'bg-violet-100',
            body: 'Fantastic time tracker at a fantastic value. The dashboard gives you, as an admin, a great breakdown of employee activity. The pricing for the functionality is outstanding as well.',
            iconColor: 'violet-500',
            logo: {
                alt: 'Capterra',
                image: capterraLogo
            }
        },
        {
            author: 'Maria Garcia',
            bg: 'bg-green-100',
            body: 'Nice, simple, intuitive. Very handy when you need to work offline with no internet. Love that the screenshots can be deleted by the user.',
            iconColor: 'green-500',
            logo: {
                alt: 'Trust pilot',
                image: trustpilotLogo
            }
        }
    ]
};
